var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgZoom = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "zoom_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#zoom_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5 35v-9.722h2.778v4.972l5.833-5.833 1.972 1.972-5.833 5.833h4.972V35H5Zm20.278 0v-2.778h4.972l-5.805-5.805 1.972-1.973 5.805 5.806v-4.972H35V35h-9.722ZM13.583 15.556 7.778 9.75v4.972H5V5h9.722v2.778H9.75l5.806 5.805-1.973 1.973Zm12.834 0-1.973-1.973 5.806-5.805h-4.972V5H35v9.722h-2.778V9.75l-5.805 5.806Z"
}))));
export default SvgZoom;